import { UserRolesEnum } from '../enums/user-roles.enum';
import { get } from '../services/storage';

export const isEstateRole = (role?: string | null): boolean => {
  return role === UserRolesEnum.estateAdmin || role === UserRolesEnum.estateUser;
};

export const isLoggedEstateRole = (): boolean => {
  return isEstateRole(get('role'));
};
